import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import './Header.less';
class Header extends React.Component {
   render() {
      const { user, logout } = this.props;
      return (
         <Navbar className="Header" >
            <Navbar.Header>
               <Navbar.Brand>
                  <a href="/" >Mart71 EMS</a>
               </Navbar.Brand>
            </Navbar.Header>
            <p className="navbar-text" >{user.name}</p>
            <ul className="nav navbar-nav pull-right" >
               <li>
                  <button onClick={() => logout()} className="navbar-btn btn btn-danger" >Logout</button>
               </li>
            </ul>
         </Navbar>
      );
   }
}

Header.propTypes = {
   user: PropTypes.object,
   logout: PropTypes.func
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/